/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

export interface InvestorReportGraph$Params {
  /**
   * ID венчурного фонда для фильтрации данных.
   */
  fund_pk?: string;

  /**
   * Номер страницы для постраничного вывода данных графика.
   */
  page?: number;

  /**
   * Период агрегации. Допустимые значения: 'month', 'year'.
   */
  period?: 'month' | 'year';
  scenario_pk: string;
}

export function investorReportGraph(
  http: HttpClient,
  rootUrl: string,
  params: InvestorReportGraph$Params,
  context?: HttpContext,
): Observable<
  BakendHttpResponse<{
    /**
     * Список периодов (месяцы или годы).
     */
    category: Array<string>;
    series: Array<{
      data: Array<number>;
      title: string;
      code: string;
    }>;
  }>
> {
  const rb = new RequestBuilder(rootUrl, investorReportGraph.PATH, 'get');
  if (params) {
    rb.query('fund_pk', params.fund_pk, {});
    rb.query('page', params.page, {});
    rb.query('period', params.period, {});
    rb.path('scenario_pk', params.scenario_pk, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<{
        /**
         * Список периодов (месяцы или годы).
         */
        category: Array<string>;
        series: Array<{
          data: Array<number>;
          title: string;
          code: string;
        }>;
      }>;
    }),
  );
}

investorReportGraph.PATH = '/api/project_calculations/investor-report/graph/{scenario_pk}/';
